import { Box, Typography } from '@material-ui/core';
import React, { FC, memo } from 'react';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

interface Props {
  icon?: React.ComponentType<SvgIconProps>;
  title?: string;
  rightContent?: React.ReactNode;
}

const Component: FC<Props> = ({
  icon: Icon = AccountBalanceIcon,
  title = 'Page module title',
  rightContent
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={{ width: '100%' }}
    >
      <Box display="flex" alignItems="center">
        {Icon ? (
          <Icon color="primary" fontSize="large" style={{ marginRight: 5 }} />
        ) : null}
        <Typography color="textPrimary" gutterBottom variant="h3">
          {title}
        </Typography>
      </Box>
      {rightContent && <Box>{rightContent}</Box>}
    </Box>
  );
};

export const PageModuleTitle = memo(Component);
